import React from 'react'
import PropTypes from 'prop-types'
import BaseIcon from '../../BaseIcon/BaseIcon'
import { ReactComponent as xTwitterIcon } from './x-twitter.svg'

const XTwitter = ({ className }) => {
	return <BaseIcon component={xTwitterIcon} className={className} viewBox="0 0 512 512" />
}

XTwitter.propTypes = {
	className: PropTypes.string,
}

export default XTwitter
